<template lang="pug">
.column.reallocation.is-flex
  .content.is-flex
    .name( v-if="!editing" ) {{name}}
    b-autocomplete(
      v-if="editing"
      class="autocomplete"
      icon="magnify"
      v-model="nameSelected"
      placeholder="Reasigne broker"
      :data="filteredDataObj"
      field="full_name"
      @select="option => selected = option.id"
    )
      template(slot="empty") No results found
    .is-flex.edit-actions
      b-button(
        v-if="!editing"
        class="edit"
        icon-left="pencil"
        @click="edit"
      )
      b-button(
        v-if="editing"
        class="edit"
        icon-left="check"
        type="is-success"
        @click="reallocation"
      )
      b-button(
        v-if="editing"
        class="edit"
        type="is-danger"
        icon-right="close"
        @click="cancelEdit"
      )
      modal-error-service(@close="closeModal")
</template>
<script>
import { RepositoryFactory } from '../services/RepositoryFactory';
import { getExecutiveList } from '../services/User/executive';
import { swapAssignedExecutives} from '../services/User/broker';
import ModalErrorService from '../views/modals/ErrorService.vue'
const QuoteRepository = RepositoryFactory.get('quotes');

export default {
  name:"ReallocationBroker",
  components: {
    ModalErrorService,
  },
  props: {
    owner: String,
    broker: Object
  },
  data(){
    return{
      editing: false,
      name: this.owner,
      selected: null,
      titleModal: "Reasignar brokers",
      nameSelected: this.owner,
      teamList: []
    }
  },
  computed: {
    filteredDataObj() {
      console.log("teamlist", this.teamList)
        return this.teamList.filter((option) => {
            return option.full_name
                .toString()
                .toLowerCase()
                .indexOf(this.nameSelected.toLowerCase()) >= 0
        })
    }
  },
  mounted() {
        getExecutiveList('operative').then( (result) => {
          this.teamList = result.data;
        })
  },
  methods: {
    closeModal(){
      this.$modal.hide('modal-error-service');
    },
    reallocation() {
      const body = {
        original: this.$route.params.id,
        substitute: this.selected 
      }
      swapAssignedExecutives(this.broker.id, body)
        .then((result) => {
          this.$buefy.toast.open({
              message: '¡Reasignación exitosa!',
              type: 'is-success'
          })
          this.editing = false;
          this.$emit('swapSuccess')
          console.log("de dio el emit")
          // this.name = result.data.data.name;
        })
        .catch((error) => {
          this.$modal.show('modal-error-service');
        })
    },
    edit(){
      this.editing = true;
    },
    cancelEdit(){
      this.editing = false;
    },
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/fonts.scss';
@import '../assets/scss/variables.scss';
  .reallocation {
    flex-direction: column;
    padding: 0;
  }
  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  label {
    font-size: 12px;
  }
  .autocomplete{
    min-width: 280px;
  }
  .name{
    margin-top: 6px;
    margin-right: 10px;
    margin-left: 37px;
    font-size: 1em;
  }
  .edit {
    border: none;
    background: $green;
    color: white;
    &:hover{
      color: white;
    }
    &:focus{
      box-shadow: none !important;
      color: white;
    }
  }
</style>